import type { PanelOverviewState } from "./todayOverviewState";

export const RING_DRAW_MS = 900;

type PeriodSnapshotLike = {
  totalScreenTimeSeconds: number | null;
  estimatedUnlockCount?: number | null;
};

type OverviewLike = {
  today?: PeriodSnapshotLike | null;
  week?: PeriodSnapshotLike;
  month?: PeriodSnapshotLike;
};

export type RingMetric = "time" | "opens";

export type RingPeriodMode = "day" | "week" | "month";

export function isTodayPanelLoading<T>(
  keepLoadingShell: boolean,
  panelState: PanelOverviewState<T>,
): boolean {
  return keepLoadingShell || panelState.status === "initial-loading" || panelState.status === "shell";
}

export function resolveRingTotal(
  overview: OverviewLike,
  mode: RingPeriodMode,
  metric: RingMetric,
): number {
  const snapshot = mode === "day" ? overview.today : mode === "week" ? overview.week : overview.month;
  const totalSeconds = snapshot?.totalScreenTimeSeconds ?? 0;
  const unlockCount = snapshot?.estimatedUnlockCount ?? undefined;

  return metric === "opens" ? (unlockCount ?? 0) : totalSeconds;
}

/** Play the clockwise draw once when real usage exists for the active metric. */
export function shouldPlayRingDrawOnReveal(ringTotal: number): boolean {
  return ringTotal > 0;
}
